import Arrows from './arrows'
import HorizontalSlide from './horizontalSlide'
import Dots from './dots'
import KeyNavigation from './keyNavigation'
import InfiniteSlides from './infiniteSlides'
import NavFor from './navFor'
import AutoPlay from './autoplay'
import PauseOnHover from './pauseOnHover'
import PauseOnArrows from './pauseOnArrows'
import PauseOnDots from './pauseOnDots'
import Fade from './fade'
import ActiveClasses from './activeClasses'
import TimerTracker from './timer'
import Swipe from './swipe'

export {
    Arrows,
    HorizontalSlide,
    Dots,
    KeyNavigation,
    InfiniteSlides,
    NavFor,
    AutoPlay,
    PauseOnHover,
    PauseOnArrows,
    PauseOnDots,
    Fade,
    ActiveClasses,
    TimerTracker,
    Swipe
}
